/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navbar_Toggle_ThemeInputs */

const es_navbar_toggle_theme = /** @type {(inputs: Navbar_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tema`)
};

const en_navbar_toggle_theme = /** @type {(inputs: Navbar_Toggle_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle theme`)
};

/**
* | output |
* | --- |
* | "Toggle theme" |
*
* @param {Navbar_Toggle_ThemeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const navbar_toggle_theme = /** @type {((inputs?: Navbar_Toggle_ThemeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navbar_Toggle_ThemeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_navbar_toggle_theme(inputs)
	return en_navbar_toggle_theme(inputs)
});
export { navbar_toggle_theme as "navbar.toggle_theme" }